import React from 'react';
import PropTypes from 'prop-types';
import { getLiveBannerLimitMessage } from './liveBannerLimit';
import styles from './LiveBannerLimitAlert.module.scss';

// Inline alert shown on Preview & Publish when the Live banner limit is reached (Figma 26974:7177)
const LiveBannerLimitAlert = ({ threshold }) => (
  <div className={styles.alert} role="alert">
    <span className={styles.icon} aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7.25" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 7.25V11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="8" cy="4.75" r="1" fill="currentColor" />
      </svg>
    </span>
    <div className={styles.content}>
      <p className={styles.title}>Unable to Publish Banner</p>
      <p className={styles.message}>{getLiveBannerLimitMessage(threshold)}</p>
    </div>
  </div>
);

LiveBannerLimitAlert.propTypes = {
  threshold: PropTypes.number.isRequired,
};

export default LiveBannerLimitAlert;
